import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

const ArtifactHealthOrderComponent = ({
  orders,
  onOrderChange
}) => (
  <div style={{ textAlign: 'right' }}>
    <div style={{ display: 'inline-block', paddingRight: '10px' }}>Order By:</div>
    <ToggleButtonGroup type="radio" name="radio" defaultValue={orders[0]}>
      {
        orders.map((f) => (
          <ToggleButton type="radio"
            key={f}
            value={f}
            name="radio"
            onChange={() => onOrderChange(f)}
          >
            {f}
          </ToggleButton>
        ))
      }
    </ToggleButtonGroup>
  </div>
);

ArtifactHealthOrderComponent.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.string),
  onOrderChange: PropTypes.func.isRequired
};

export default ArtifactHealthOrderComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthOrderComponent.jsx